import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const PAPER_CREAM = '#f7f3eb';
const PAPER_CREAM_DARK = '#ebe6dc';
const PAPER_WARM = '#e8e2d6';

const sketchDraw = keyframes`
  from { stroke-dashoffset: 1500; }
  to { stroke-dashoffset: 0; }
`;

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, 
    ${PAPER_CREAM} 0%, ${PAPER_CREAM_DARK} 30%, ${PAPER_WARM} 70%, #e5dfd2 100%
  );
  z-index: 1;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: 
      repeating-linear-gradient(90deg, transparent 0 1px, rgba(139,119,101,0.015) 1px 2px),
      repeating-linear-gradient(0deg, transparent 0 1px, rgba(139,119,101,0.015) 1px 2px);
    pointer-events: none;
  }
`;

const SketchLayer = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const SketchPath = styled.path<{ delay?: number; duration?: number }>`
  fill: none;
  stroke: rgba(109, 107, 73, 0.06);
  stroke-width: 0.25;
  stroke-dasharray: 1500;
  stroke-dashoffset: 1500;
  stroke-linecap: round;
  stroke-linejoin: round;
  animation: ${sketchDraw} ${props => props.duration ?? 25}s ease-in-out ${props => props.delay ?? 0}s infinite alternate;
`;

const PaperDrawingBackground = () => (
  <Background>
    <SketchLayer viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice">
      <SketchPath d="M 5 30 Q 50 10, 95 40" delay={0} duration={28} />
      <SketchPath d="M 15 70 Q 55 85, 90 55" delay={8} duration={32} />
      <SketchPath d="M 0 50 Q 40 30, 100 65" delay={15} duration={26} />
    </SketchLayer>
  </Background>
);

export default PaperDrawingBackground;
